type Data  = {
  title: string,
  value: string | number,
  visible: boolean
}
export function useFeatures(allowedFeatures: string[] = [], features: []) {

  let data: Data[] = [];

  allowedFeatures.forEach((key) => {
    if (features[key]) {

      data.push(
        {
          title: features[key].label,
          value: features[key].value,
          visible: features[key].visible
        }
      );
    }

  });

  return data;
}